export default "__VITE_ASSET__l1XzMabA__"